"use client";

import { useState } from "react";

/**
 * Set logo on a dark key-art plate (Collectr). Logos come from mixed sources
 * (pokemontcg.io wordmarks, TCGplayer set-icons) and many TCGplayer icons 404 —
 * especially Japanese/promo sets. So a missing OR failed image degrades to the
 * set name text instead of a broken-image plate.
 */
export function SetLogo({ logoUrl, name }: { logoUrl: string | null; name: string }) {
  const [failed, setFailed] = useState(false);
  const showText = !logoUrl || failed;
  // Drop the TCGplayer-style "SV4a:" code prefix for a cleaner typographic
  // plate (the full name still shows on the card below). This is the intended
  // last resort — a styled set name reads better than a tiny set-symbol icon.
  const label = name.replace(/^[A-Za-z0-9.\-&\s]{1,14}:\s*/, "") || name;

  return (
    <div className="flex h-24 items-center justify-center overflow-hidden rounded-xl border border-strong bg-background-800 px-4 py-3">
      {showText ? (
        <span className="line-clamp-3 px-1 text-center font-serif text-[15px] font-semibold leading-tight text-body">
          {label}
        </span>
      ) : (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={logoUrl}
          alt=""
          loading="lazy"
          className="max-h-full max-w-full object-contain drop-shadow-[0_1px_6px_rgba(0,0,0,0.5)]"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
